module.exports = {
  "country": "BE",
  "artist": "Urban Trad",
  "song": "Sanomi",
  "year": "2003",
  "place": "2",
  "spotify": "0uz28wQ7LSe4xU3CkOpFKh"
};